import './TestAIChat.scss'
import * as React from 'react';
import { FC, useEffect, useRef, useState } from "react";
import { Message } from '../../../models';
import { getClientAsync, sendChatMessage } from '../../../ajax/requests';
import { useSelector } from 'react-redux';
import { getEntitiesDataItems } from '../../../store/entities/selectors';
import { ClientEntity } from '../../../store/entities/state';
import { AutocompleteTextField } from '../../../components/Forms/fields';
import { useIsMount } from '../../../shared/hooks/useIsMount';
import {
  createClientSearchConfig,
} from '../../../shared/clientSearch';


export const TestAIChat: FC = () => {

  const isMount = useIsMount()

  const [messages, setMessages] = useState<Message[]>([{isAssistant: true, content: 'Como posso ajudar?'}])
  const [writting, setWritting] = useState<string>('')
  const [sending, setSending] = useState(false)
  const [selectedClientId, setSelectedClientId] = useState<string|undefined>(undefined)
  const [phoneNumber, setPhoneNumber] = useState<string|undefined>(undefined)

  const clients = useSelector(getEntitiesDataItems<ClientEntity>('clients'))
  const clientSearchConfig = React.useMemo(() => createClientSearchConfig(clients), [clients])

  const messagesContainerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    messagesContainerRef.current?.scrollTo({
      top: messagesContainerRef.current?.scrollHeight,
      behavior: 'smooth',
    })
  }, [messages])

  const sendMessage = (start = false) => {
    if (sending) return
    if (!start && !writting.length) return

    const newMsgs: Message[] = start ? [] : [...messages, {isAssistant: false, content: writting}]

    setMessages([
      ...newMsgs, 
      {isAssistant: true, content: '...'},
    ])
    setWritting('')
    
    setSending(true)
    sendChatMessage({clientPhoneNumber: phoneNumber ?? '', messages: newMsgs})
      .then(({answer}) => {
        setMessages([...newMsgs, {isAssistant: true, content: answer}])
      })
      .catch((e) => {
        console.error(e)
        setMessages([
          ...newMsgs,
          {isAssistant: true, content: 'ERROR'},
        ])
      })
      .finally(() => setSending(false))
  }

  const onClientChange = (option: string) => {
    const client = clientSearchConfig.getClientByOption(option)
    setSelectedClientId(client?.id)

    if (!client?.id) setPhoneNumber(undefined)
    else {
      getClientAsync(client.id).then(c => c && setPhoneNumber(c.phoneNumbers?.[0]))
    }
  }

  useEffect(() => {
    if (isMount) return;
    setMessages([])
    sendMessage(true)
  }, [phoneNumber])
  
  return (<>
    <AutocompleteTextField 
      id="impersonate-client-name"
      value={clientSearchConfig.getOptionByClientId(selectedClientId) ?? ''}
      options={clientSearchConfig.options}
      optionLabelResolver={clientSearchConfig.optionLabelResolver}
      searchTextResolver={clientSearchConfig.searchTextResolver}
      searchMatcher={clientSearchConfig.searchMatcher}
      onValueChanged={onClientChange} />

    <div className='chat-window'>
      <div className='chat active-chat' ref={messagesContainerRef}>
        {messages.map(({isAssistant, content}, i) => (
          <div key={i} className={`bubble ${isAssistant ? 'you' : 'me'}`}>
            {content.split('**').map((m, index) => index % 2 !== 0 ? <strong key={index}>{m}</strong> : <React.Fragment key={index}>{m}</React.Fragment>)}
          </div>
        ))}
      </div>
      <div className="write">
        <input 
          type="text" 
          value={writting} 
          onChange={evt => setWritting(evt.target.value)}
          onKeyDown={evt => evt.key === 'Enter' && sendMessage()}
        />
        <button type="button" onClick={() => sendMessage()} className="write-link send" aria-label="Send message"/>
      </div>
    </div>
  </>)

}
